import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { AUTH_TOKEN } from "constants/AuthConstant";
import approvalComponentMasterService from "services/Setup/ApprovalComponentMaster/approvalComponentMasterService";
import { message, notification } from "antd";

export const initialState = {
  loading: false,
  loadingApprovalComponentMaster: false,
  message: "",
  statusRespon: "",
  showMessage: false,
  redirect: "",
  token: localStorage.getItem(AUTH_TOKEN) || null,
  result: {},
  approvalComponentList: {},
};

export const getApprovalComponentMaster = createAsyncThunk(
  "approvalComponentMaster/getApprovalComponentMaster",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await approvalComponentMasterService.getApprovalComponentMasterService(
          userInput
        );
      if (response.status === 200) {
        if (response && response.data) {
          return response.data;
        }
      } else {
        console.log("Selain Response 200");
        // notification.error({
        //   message: "Error",
        //   description: "Unexpected response!",
        //   duration: 3,
        // });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      console.log("🚀 ~ error in signIn:", error);
      // notification.error({
      //   message: "Error",
      //   description: "Unexpected response!",
      //   duration: 3,
      // });
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const postApprovalComponentMaster = createAsyncThunk(
  "approvalComponentMaster/postApprovalComponentMaster",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await approvalComponentMasterService.postApprovalComponentMaster(
          userInput
        );

      if (response.status === 200) {
        if (
          response.data.status == "Success" ||
          response.data.status == "Approved"
        ) {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const putApprovalComponentMaster = createAsyncThunk(
  "approvalComponentMaster/putApprovalComponentMaster",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await approvalComponentMasterService.putApprovalComponentMaster(
          userInput
        );

      if (response.status === 200) {
        if (
          response.data.status == "Success" ||
          response.data.status == "Approved"
        ) {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const deleteApprovalComponentMaster = createAsyncThunk(
  "approvalComponentMaster/deleteApprovalComponentMaster",
  async (userInput, { rejectWithValue }) => {
    try {
      const response =
        await approvalComponentMasterService.deleteApprovalComponentMaster(
          userInput
        );

      if (response.status === 200) {
        if (
          response.data.status == "Success" ||
          response.data.status == "Approved"
        ) {
          notification.success({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        } else {
          notification.error({
            message: response.data.status,
            description: response.data.message,
            duration: 3,
          });
        }
        return response.data;
      } else {
        //Selain Response 200
        console.log("Selain Response 200");
        notification.error({
          message: "Error",
          description: "Unexpected response!",
          duration: 3,
        });
        return rejectWithValue({
          status: "Error",
          response: response?.data?.message || "Unexpected response!",
        });
      }
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Unexpected response!"
      );
    }
  }
);

export const approvalComponentMaster = createSlice({
  name: "approvalComponentMaster",
  initialState,
  reducers: {
    showNotification: (state, action) => {
      state.message = action.payload;
      state.showMessage = true;
      state.loading = false;
    },
    hideNotification: (state) => {
      state.message = "";
      state.showMessage = false;
    },
    showLoading: (state) => {
      state.loading = true;
    },
  },

  extraReducers: (builder) => {
    builder
      //get Prospect List
      .addCase(getApprovalComponentMaster.pending, (state) => {
        state.loading = true;
        state.redirect = "";
      })
      .addCase(getApprovalComponentMaster.fulfilled, (state, action) => {
        state.loading = false;
        state.approvalComponentList = action.payload;
        state.getCount = action.payload.count;
      })
      .addCase(getApprovalComponentMaster.rejected, (state, action) => {
        state.loading = false;
        state.result = action.payload;
        state.showMessage = true;
      })

      //   post
      .addCase(postApprovalComponentMaster.pending, (state) => {
        state.loadingApprovalComponentMaster = true;
        state.statusRespon = "";
      })
      .addCase(postApprovalComponentMaster.fulfilled, (state, action) => {
        state.loadingApprovalComponentMaster = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(postApprovalComponentMaster.rejected, (state, action) => {
        state.loadingApprovalComponentMaster = false;
        state.result = action.payload;
        state.statusRespon = "Error";
        state.showMessage = true;
      })
      //   put
      .addCase(putApprovalComponentMaster.pending, (state) => {
        state.loadingApprovalComponentMaster = true;
        state.statusRespon = "";
      })
      .addCase(putApprovalComponentMaster.fulfilled, (state, action) => {
        state.loadingApprovalComponentMaster = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(putApprovalComponentMaster.rejected, (state, action) => {
        state.loadingApprovalComponentMaster = false;
        state.result = action.payload;
        state.statusRespon = "Error";
        state.showMessage = true;
      })
      //   delete
      .addCase(deleteApprovalComponentMaster.pending, (state) => {
        state.loadingApprovalComponentMaster = true;
        state.statusRespon = "";
      })
      .addCase(deleteApprovalComponentMaster.fulfilled, (state, action) => {
        state.loadingApprovalComponentMaster = false;
        state.redirect = "/";
        state.result = action?.payload;
        state.showMessage = true;
        state.message = action?.payload?.message;
        state.refreshList = true;
        state.statusRespon = action?.payload?.status;
      })
      .addCase(deleteApprovalComponentMaster.rejected, (state, action) => {
        state.loadingApprovalComponentMaster = false;
        state.result = action.payload;
        state.statusRespon = "Error";
        state.showMessage = true;
      });
  },
});

export const { showNotification, hideNotification, showLoading } =
  approvalComponentMaster.actions;

export default approvalComponentMaster.reducer;
